import React from "react";

export const ArchiveIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.27 2.615L9.575 1.775C9.44 1.605 9.235 1.5 9 1.5H3C2.765 1.5 2.56 1.605 2.42 1.775L1.73 2.615C1.585 2.785 1.5 3.01 1.5 3.25V9.5C1.5 10.05 1.95 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V3.25C10.5 3.01 10.415 2.785 10.27 2.615ZM6 8.75L3.25 6H5V5H7V6H8.75L6 8.75ZM2.56 2.5L2.965 2H8.965L9.435 2.5H2.56Z"
      fill="black"
    />
  </svg>
);

export const CheckmarkIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.39754 7.93746L2.31254 5.85246L1.60254 6.55746L4.39754 9.35246L10.3975 3.35246L9.69254 2.64746L4.39754 7.93746Z"
      fill="black"
    />
  </svg>
);

export const LogoutIcon = ({ size = 16, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 9v6h4v5h-4c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2h4v5h-4zm11 3l-4-4v3h-6v2h6v3l4-4z" />
  </svg>
);

export const ChatbotIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
  >
    <g clipPath="url(#clip0_102_727)">
      <path
        d="M22.5 9H22V8C22 5.243 19.757 3 17 3H13V1C13 0.448 12.553 0 12 0C11.447 0 11 0.448 11 1V3H7C4.243 3 2 5.243 2 8V9H1.5C0.673 9 0 9.673 0 10.5V13.5C0 14.327 0.673 15 1.5 15H2V16C2 18.757 4.243 21 7 21H14.697L18.66 23.642C19.02 23.882 19.435 24.003 19.851 24.003C20.199 24.003 20.547 23.919 20.866 23.748C21.565 23.373 22 22.648 22 21.854V14.999H22.5C23.327 14.999 24 14.326 24 13.499V10.499C24 9.672 23.327 8.999 22.5 8.999V9ZM8.5 8C9.328 8 10 8.672 10 9.5C10 10.328 9.328 11 8.5 11C7.672 11 7 10.328 7 9.5C7 8.672 7.672 8 8.5 8ZM16.531 15.573C15.494 16.224 13.865 17 12 17C10.135 17 8.506 16.224 7.469 15.573C7.001 15.28 6.86 14.662 7.154 14.195C7.448 13.728 8.065 13.586 8.532 13.879C9.347 14.391 10.611 15 12.001 15C13.391 15 14.654 14.391 15.47 13.879C15.936 13.585 16.555 13.727 16.848 14.195C17.142 14.663 17 15.28 16.533 15.573H16.531ZM15.5 11C14.672 11 14 10.328 14 9.5C14 8.672 14.672 8 15.5 8C16.328 8 17 8.672 17 9.5C17 10.328 16.328 11 15.5 11Z"
        fill={props.fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_102_727">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SendIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 48 48"
    fill="none"
    className={props.className}
  >
    <rect width="48" height="48" fill="white"></rect>
    <path
      d="M31.0819 19.9282L21.0952 14.9349C14.3869 11.5749 11.6336 14.3282 14.9936 21.0366L16.0086 23.0666C16.3002 23.6616 16.3002 24.3499 16.0086 24.9449L14.9936 26.9632C11.6336 33.6716 14.3752 36.4249 21.0952 33.0649L31.0819 28.0716C35.5619 25.8316 35.5619 22.1682 31.0819 19.9282V19.9282ZM27.3136 24.8749H21.0136C20.5352 24.8749 20.1386 24.4782 20.1386 23.9999C20.1386 23.5216 20.5352 23.1249 21.0136 23.1249H27.3136C27.7919 23.1249 28.1886 23.5216 28.1886 23.9999C28.1886 24.4782 27.7919 24.8749 27.3136 24.8749Z"
      fill={props.fill}
    ></path>
  </svg>
);

export const EmojiIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
  >
    <g clip-path="url(#clip0_108_729)">
      <path
        d="M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519943 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693605 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519943 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9966 15.1815 22.7312 18.2318 20.4815 20.4815C18.2318 22.7312 15.1815 23.9966 12 24ZM12 2.00001C10.0222 2.00001 8.08879 2.5865 6.4443 3.68531C4.79981 4.78412 3.51809 6.34591 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9971 9.34873 20.9426 6.80689 19.0679 4.93215C17.1931 3.05742 14.6513 2.00292 12 2.00001ZM17.666 15.746C17.8641 15.5696 17.9841 15.3218 17.9994 15.057C18.0148 14.7922 17.9244 14.5321 17.748 14.334C17.5716 14.1359 17.3238 14.0159 17.059 14.0006C16.7942 13.9852 16.5341 14.0756 16.336 14.252C15.1135 15.2813 13.5945 15.8936 12 16C10.4064 15.8937 8.88823 15.2821 7.66601 14.254C7.46815 14.0774 7.20824 13.9866 6.94344 14.0016C6.67864 14.0166 6.43064 14.1362 6.25401 14.334C6.07737 14.5319 5.98657 14.7918 6.00157 15.0566C6.01657 15.3214 6.13615 15.5694 6.33401 15.746C7.92187 17.1025 9.91422 17.8951 12 18C14.0858 17.8951 16.0781 17.1025 17.666 15.746ZM6.00001 10C6.00001 11 6.89501 11 8.00001 11C9.10501 11 10 11 10 10C10 9.46957 9.78929 8.96087 9.41422 8.58579C9.03915 8.21072 8.53044 8.00001 8.00001 8.00001C7.46957 8.00001 6.96086 8.21072 6.58579 8.58579C6.21072 8.96087 6.00001 9.46957 6.00001 10ZM14 10C14 11 14.895 11 16 11C17.105 11 18 11 18 10C18 9.46957 17.7893 8.96087 17.4142 8.58579C17.0391 8.21072 16.5304 8.00001 16 8.00001C15.4696 8.00001 14.9609 8.21072 14.5858 8.58579C14.2107 8.96087 14 9.46957 14 10Z"
        fill={props.fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_108_729">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 12 12"
    fill="none"
    className={props.className}
  >
    <path
      d="M11.3 10.2L9.1001 7.99995C9.6501 7.19995 10 6.24997 10 5.19997C10 2.59997 7.85 0.449951 5.25 0.449951C2.65 0.449951 0.5 2.59997 0.5 5.19997C0.5 7.79997 2.65 9.94997 5.25 9.94997C6.3 9.94997 7.25005 9.59994 8.05005 9.04994L10.25 11.25L11.3 10.2ZM2 5.24995C2 3.44995 3.45 1.99995 5.25 1.99995C7.05 1.99995 8.5 3.44995 8.5 5.24995C8.5 7.04995 7.05 8.49995 5.25 8.49995C3.45 8.49995 2 7.04995 2 5.24995Z"
      fill={props.fill}
    />
  </svg>
);

export const ChevronRightIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
  >
    <path
      d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z"
      fill={props.fill}
    />
  </svg>
);

export const WarningIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
  >
    <path
      d="M1 21.5H23L12 2.5L1 21.5ZM13 18.5H11V16.5H13V18.5ZM13 14.5H11V10.5H13V14.5Z"
      fill={props.fill}
    />
  </svg>
);

export const InfoIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
  >
    <path
      d="M1 21.5H23L12 2.5L1 21.5ZM13 18.5H11V16.5H13V18.5ZM13 14.5H11V10.5H13V14.5Z"
      fill={props.fill}
    />
  </svg>
);

export const PlusIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    className={props.className}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill={props.fill} />
  </svg>
);

export const DropdownIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.295 4.14763L6 6.43763L3.705 4.14763L3 4.85263L6 7.85263L9 4.85263L8.295 4.14763Z"
      fill="black"
    />
  </svg>
);
export const CrossIcon = (props) => (
  <svg
    className="cursor-pointer"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0664 3.39998L12.5998 1.93335L7.99976 6.60002L3.39974 1.93335L1.93311 3.39998L6.59977 8L1.93311 12.6L3.39974 14.0667L7.99976 9.39998L12.5998 14.0667L14.0664 12.6L9.39974 8L14.0664 3.39998Z"
      fill="black"
    />
  </svg>
);

export const VibilityWindowIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 1L3.005 4L5 6L3.005 8.005L3 11H9V8L7 6L9 4.005V1H3ZM8 8.25V10H4V8.25L6 6.25L8 8.25Z"
      fill="currentColor"
    />
  </svg>
);
export const BatteryIcon = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.5 2.5V10.5C8.5 10.775 8.275 11 8 11H4C3.725 11 3.5 10.775 3.5 10.5V2.5C3.5 2.225 3.725 2 4 2H5V1H7V2H8C8.275 2 8.5 2.225 8.5 2.5ZM7.5 3H4.5V4H7.5V3Z" fill="currentColor"/>
  </svg>
  
);

export const TempratureRangeIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 6.5V2.5C7.5 1.67 6.83 1 6 1C5.17 1 4.5 1.67 4.5 2.5V6.5C3.895 6.955 3.5 7.685 3.5 8.5C3.5 9.88 4.62 11 6 11C7.38 11 8.5 9.88 8.5 8.5C8.5 7.685 8.105 6.955 7.5 6.5ZM5.5 5.5V2.5C5.5 2.225 5.725 2 6 2C6.275 2 6.5 2.225 6.5 2.5V3H6V3.5H6.5V4.5H6V5H6.5V5.5H5.5Z"
      fill="currentColor"
    />
  </svg>
);
export const ShockIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.81507 5.04972C7.75589 4.85795 7.67421 4.68632 7.57005 4.5348C7.46825 4.38092 7.34514 4.24953 7.20073 4.14062C7.05868 4.03172 6.89533 3.95005 6.71067 3.8956C6.52601 3.83878 6.32478 3.81037 6.10698 3.81037C5.71635 3.81037 5.36834 3.90862 5.06294 4.10511C4.75755 4.30161 4.51725 4.59044 4.34206 4.97159C4.16924 5.35038 4.08283 5.81203 4.08283 6.35653C4.08283 6.90578 4.16924 7.37098 4.34206 7.75213C4.51489 8.13329 4.75518 8.4233 5.06294 8.62216C5.37071 8.81866 5.72819 8.9169 6.13539 8.9169C6.50471 8.9169 6.82431 8.84588 7.09419 8.70384C7.36645 8.56179 7.57596 8.36056 7.72275 8.10014C7.86953 7.83736 7.94292 7.52959 7.94292 7.17685L8.24121 7.22301H6.26678V6.19318H9.21777V7.06676C9.21777 7.68939 9.0852 8.22798 8.82005 8.68253C8.55489 9.13707 8.19031 9.48745 7.7263 9.73366C7.26228 9.97751 6.72961 10.0994 6.12828 10.0994C5.4583 10.0994 4.87 9.9491 4.36337 9.64844C3.85911 9.34541 3.46493 8.91572 3.18084 8.35938C2.89912 7.80066 2.75826 7.13778 2.75826 6.37074C2.75826 5.78362 2.84112 5.25923 3.00684 4.79759C3.17492 4.33594 3.4093 3.94413 3.70996 3.62216C4.01062 3.29782 4.36337 3.05161 4.7682 2.88352C5.17303 2.71307 5.61337 2.62784 6.08922 2.62784C6.49168 2.62784 6.86692 2.68703 7.21493 2.8054C7.56294 2.9214 7.87189 3.08712 8.14178 3.30256C8.41403 3.51799 8.63775 3.77367 8.81294 4.0696C8.98813 4.36553 9.10295 4.69223 9.1574 5.04972H7.81507Z"
      fill="currentColor"
    />
  </svg>
);
export const LightIcon = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_13810_46620)">
  <path d="M6 3.5C4.62 3.5 3.5 4.62 3.5 6C3.5 7.38 4.62 8.5 6 8.5C7.38 8.5 8.5 7.38 8.5 6C8.5 4.62 7.38 3.5 6 3.5ZM1 6.5H2C2.275 6.5 2.5 6.275 2.5 6C2.5 5.725 2.275 5.5 2 5.5H1C0.725 5.5 0.5 5.725 0.5 6C0.5 6.275 0.725 6.5 1 6.5ZM10 6.5H11C11.275 6.5 11.5 6.275 11.5 6C11.5 5.725 11.275 5.5 11 5.5H10C9.725 5.5 9.5 5.725 9.5 6C9.5 6.275 9.725 6.5 10 6.5ZM5.5 1V2C5.5 2.275 5.725 2.5 6 2.5C6.275 2.5 6.5 2.275 6.5 2V1C6.5 0.725 6.275 0.5 6 0.5C5.725 0.5 5.5 0.725 5.5 1ZM5.5 10V11C5.5 11.275 5.725 11.5 6 11.5C6.275 11.5 6.5 11.275 6.5 11V10C6.5 9.725 6.275 9.5 6 9.5C5.725 9.5 5.5 9.725 5.5 10ZM2.995 2.29C2.8 2.095 2.48 2.095 2.29 2.29C2.095 2.485 2.095 2.805 2.29 2.995L2.82 3.525C3.015 3.72 3.335 3.72 3.525 3.525C3.715 3.33 3.72 3.01 3.525 2.82L2.995 2.29ZM9.18 8.475C8.985 8.28 8.665 8.28 8.475 8.475C8.28 8.67 8.28 8.99 8.475 9.18L9.005 9.71C9.2 9.905 9.52 9.905 9.71 9.71C9.905 9.515 9.905 9.195 9.71 9.005L9.18 8.475ZM9.71 2.995C9.905 2.8 9.905 2.48 9.71 2.29C9.515 2.095 9.195 2.095 9.005 2.29L8.475 2.82C8.28 3.015 8.28 3.335 8.475 3.525C8.67 3.715 8.99 3.72 9.18 3.525L9.71 2.995ZM3.525 9.18C3.72 8.985 3.72 8.665 3.525 8.475C3.33 8.28 3.01 8.28 2.82 8.475L2.29 9.005C2.095 9.2 2.095 9.52 2.29 9.71C2.485 9.9 2.805 9.905 2.995 9.71L3.525 9.18Z" fill="currentColor"/>
  </g>
  <defs>
  <clipPath id="clip0_13810_46620">
  <rect width="12" height="12" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
);
export const TiltIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.28638 6.34622L8.86931 2.52443C8.96374 2.4237 8.95864 2.2655 8.85791 2.17106L8.49314 1.82909C8.39241 1.73466 8.2342 1.73976 8.13977 1.84049L1.20308 9.23963C0.747308 9.72578 1.10476 10.5001 1.75151 10.5001H10.4255C10.5636 10.5001 10.6755 10.3881 10.6755 10.2501V9.75008C10.6755 9.61201 10.5636 9.50008 10.4255 9.50008H6.65274C6.60245 8.94922 6.46926 8.40813 6.25685 7.89533C6.02175 7.32774 5.69351 6.80427 5.28638 6.34622ZM2.32964 9.50008H5.64765C5.60077 9.08079 5.49506 8.66933 5.33297 8.27801C5.1523 7.84184 4.90442 7.43752 4.59896 7.07947L2.32964 9.50008Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.64765 9.50008C5.63829 9.4164 5.62659 9.33303 5.61257 9.25008C5.55633 8.91736 5.46271 8.59124 5.33297 8.27801C5.18463 7.91989 4.99098 7.58324 4.75735 7.27604C4.70644 7.20909 4.65362 7.14354 4.59896 7.07947L2.32964 9.50008H5.64765ZM5.35881 9.25008C5.30506 8.95028 5.21911 8.65642 5.102 8.37368C4.96732 8.04854 4.79309 7.74214 4.5838 7.46117L2.9067 9.25008H5.35881ZM5.28638 6.34622C5.69351 6.80427 6.02175 7.32774 6.25685 7.89533C6.46926 8.40813 6.60245 8.94922 6.65274 9.50008H10.4255C10.5636 9.50008 10.6755 9.61201 10.6755 9.75008V10.2501C10.6755 10.3881 10.5636 10.5001 10.4255 10.5001H1.75151C1.10476 10.5001 0.747308 9.72578 1.20308 9.23963L8.13977 1.84049C8.2342 1.73976 8.39241 1.73466 8.49314 1.82909L8.85791 2.17106C8.95864 2.2655 8.96374 2.4237 8.86931 2.52443L5.28638 6.34622ZM6.87639 9.25008C6.81096 8.75276 6.6806 8.26507 6.48782 7.79966C6.27129 7.27692 5.97921 6.78997 5.62173 6.35404L9.05169 2.69542C9.24056 2.49396 9.23035 2.17754 9.02889 1.98868L8.66412 1.64671C8.46267 1.45784 8.14625 1.46805 7.95739 1.66951L1.02069 9.06864C0.409493 9.72059 0.894333 10.7501 1.75151 10.7501H10.4255C10.7017 10.7501 10.9255 10.5262 10.9255 10.2501V9.75008C10.9255 9.47393 10.7017 9.25008 10.4255 9.25008H6.87639Z"
      fill="currentColor"
    />
  </svg>
);
export const PressureIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33582 5.66418C5.66914 5.99751 6.20958 5.99751 6.54291 5.66418C6.87624 5.33086 7.75 3.25 7.75 3.25C7.75 3.25 5.66914 4.12376 5.33582 4.45709C5.00249 4.79042 5.00249 5.33086 5.33582 5.66418Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 1C3.79086 1 2 2.79086 2 5C2 6.86384 3.27477 8.42994 5 8.87398V10H1.25C1.11193 10 1 10.1119 1 10.25V11.25C1 11.3881 1.11193 11.5 1.25 11.5H10.75C10.8881 11.5 11 11.3881 11 11.25V10.25C11 10.1119 10.8881 10 10.75 10H7V8.87398C8.72523 8.42994 10 6.86384 10 5C10 2.79086 8.20914 1 6 1ZM3 5C3 3.34315 4.34315 2 6 2C7.65685 2 9 3.34315 9 5C9 6.65685 7.65685 8 6 8C4.34315 8 3 6.65685 3 5Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 9C8.20914 9 10 7.20914 10 5C10 2.79086 8.20914 1 6 1C3.79086 1 2 2.79086 2 5C2 7.20914 3.79086 9 6 9ZM6 9.5C8.48528 9.5 10.5 7.48528 10.5 5C10.5 2.51472 8.48528 0.5 6 0.5C3.51472 0.5 1.5 2.51472 1.5 5C1.5 7.48528 3.51472 9.5 6 9.5Z"
      fill="currentColor"
    />
  </svg>
);
export const HumidityIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1C3.335 3.275 2 5.24 2 6.9C2 9.39 3.9 11 6 11C8.1 11 10 9.39 10 6.9C10 5.24 8.665 3.275 6 1ZM3.915 7C4.1 7 4.25 7.13 4.285 7.31C4.49 8.42 5.425 8.8 6.105 8.745C6.32 8.735 6.5 8.905 6.5 9.12C6.5 9.32 6.34 9.485 6.14 9.495C5.075 9.56 3.83 8.95 3.545 7.435C3.505 7.21 3.685 7 3.915 7Z"
      fill="currentColor"
    />
  </svg>
);


export const HomeProductIcon = (props) => (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.6933 3.48667L12.7667 2.36667C12.5867 2.14 12.3133 2 12 2H4C3.68667 2 3.41333 2.14 3.22667 2.36667L2.30667 3.48667C2.11333 3.71333 2 4.01333 2 4.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V4.33333C14 4.01333 13.8867 3.71333 13.6933 3.48667ZM4.16 3.33333H11.84L12.6667 4.33333H3.33333L4.16 3.33333ZM3.33333 12.6667V5.33333H12.6667V12.6667H3.33333Z" fill="currentColor"/>
<path d="M12.667 13.333H3.33301V5.33301H12.667V13.333ZM6 5.66699V9H10V5.66699H6Z" fill="currentColor"/>
</svg>  
);
export const HomeTemperatureIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99984 8.66665V3.33331C9.99984 2.22665 9.1065 1.33331 7.99984 1.33331C6.89317 1.33331 5.99984 2.22665 5.99984 3.33331V8.66665C5.19317 9.27331 4.6665 10.2466 4.6665 11.3333C4.6665 13.1733 6.15984 14.6666 7.99984 14.6666C9.83984 14.6666 11.3332 13.1733 11.3332 11.3333C11.3332 10.2466 10.8065 9.27331 9.99984 8.66665ZM7.33317 7.33331V3.33331C7.33317 2.96665 7.63317 2.66665 7.99984 2.66665C8.3665 2.66665 8.6665 2.96665 8.6665 3.33331V3.99998H7.99984V4.66665H8.6665V5.99998H7.99984V6.66665H8.6665V7.33331H7.33317Z" fill="currentColor"/>
</svg>

);
export const HomeTeamsIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1132 8.75335C12.0265 9.37335 12.6665 10.2134 12.6665 11.3334V13.3334H15.3332V11.3334C15.3332 9.88002 12.9532 9.02002 11.1132 8.75335Z" fill="currentColor"/>
  <path d="M5.99984 8.00002C7.4726 8.00002 8.6665 6.80611 8.6665 5.33335C8.6665 3.86059 7.4726 2.66669 5.99984 2.66669C4.52708 2.66669 3.33317 3.86059 3.33317 5.33335C3.33317 6.80611 4.52708 8.00002 5.99984 8.00002Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99984 8.00002C11.4732 8.00002 12.6665 6.80669 12.6665 5.33335C12.6665 3.86002 11.4732 2.66669 9.99984 2.66669C9.6865 2.66669 9.39317 2.73335 9.11317 2.82669C9.6665 3.51335 9.99984 4.38669 9.99984 5.33335C9.99984 6.28002 9.6665 7.15335 9.11317 7.84002C9.39317 7.93335 9.6865 8.00002 9.99984 8.00002Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99984 8.66669C4.21984 8.66669 0.666504 9.56002 0.666504 11.3334V13.3334H11.3332V11.3334C11.3332 9.56002 7.77984 8.66669 5.99984 8.66669Z" fill="currentColor"/>
  </svg>
  
);
export const HomeRiskIcon = (props) => (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.4867 2H5.51333L2 5.51333V10.4867L5.51333 14H10.4867L14 10.4867V5.51333L10.4867 2ZM8 11.5333C7.52 11.5333 7.13333 11.1467 7.13333 10.6667C7.13333 10.1867 7.52 9.8 8 9.8C8.48 9.8 8.86667 10.1867 8.86667 10.6667C8.86667 11.1467 8.48 11.5333 8 11.5333ZM8.66667 8.66667H7.33333V4.66667H8.66667V8.66667Z" fill="currentColor"/>
</svg>


);
export const HomeCloudIcon = (props) => (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 3.99996C9.74667 3.99996 11.2533 5.23996 11.5933 6.95329L11.7933 7.95329L12.8133 8.02663C13.8533 8.09329 14.6667 8.96663 14.6667 9.99996C14.6667 11.1 13.7667 12 12.6667 12H4C2.52667 12 1.33333 10.8066 1.33333 9.33329C1.33333 7.96663 2.35333 6.82663 3.70667 6.68663L4.42 6.61329L4.75333 5.97996C5.38667 4.75996 6.62667 3.99996 8 3.99996ZM8 2.66663C6.07333 2.66663 4.4 3.75996 3.56667 5.35996C1.56 5.57329 0 7.27329 0 9.33329C0 11.54 1.79333 13.3333 4 13.3333H12.6667C14.5067 13.3333 16 11.84 16 9.99996C16 8.23996 14.6333 6.81329 12.9 6.69329C12.4467 4.39329 10.4267 2.66663 8 2.66663Z" fill="currentColor"/>
</svg>

);

